import { format } from "date-fns";
import { apiClient } from "shared/utils";
import { SubscriptionExportRequestRequest, SubscriptionExportRequestResponse } from "api/models";

export const postSubscriptionExportRequest = async ({
  shopId,
  startDate,
  endDate
}: SubscriptionExportRequestRequest) => {
  const { data } = await apiClient.post<SubscriptionExportRequestResponse>(
    `/${shopId}/dashboard/subscriptions/exports`,
    undefined,
    {
      params: {
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd")
      }
    }
  );

  return data;
};
